<script lang="ts" setup>
const props = withDefaults(defineProps<{
  size?: 'sm' | 'md'
}>(), {
  size: 'md',
})
const sizeClasses = computed(() => props.size === 'sm' ? ['prose-sm'] : [])
</script>

<template>
  <div
    :class="[...sizeClasses]"
    class="
        prose
        text-foreground
        prose-headings:font-semibold
        prose-h1:!text-3xl
        prose-h2:!mb-4
        prose-h2:!mt-10
        prose-h2:!text-lg
        prose-h3:!my-1
        prose-h3:!text-base
        prose-h4:!my-1
        prose-h4:!text-sm
        prose-h5:!my-1
        prose-h5:!text-xs
        prose-h6:!my-1
        prose-h6:!text-xs
        [&_ul>li::marker]:text-current
        "
  >
    <slot />
  </div>
</template>
